
import { defineComponent, onMounted } from 'vue';
import { AppTable, AppCard, AppButton } from '@/components';
import { useCreditList } from '@/modules/credit/ticket/model/list';
import { ROUTE_NAME_CREDIT } from '@/modules/credit/ticket/router';
import { InjectionFeature } from '@/common/reward/types';
import { ROUTE_NAME_ITEM } from '@/modules/item/router';
import { ROUTE_NAME_PROMOTION } from '@/modules/promotion/router';
import { TableColumnType, TableConfig } from '@/components/table/types';

export default defineComponent({
    name: ROUTE_NAME_CREDIT.TICKET.INDEX,
    components: { AppTable, AppCard, AppButton },
    setup() {
        const { list, total, fetchList, actions } = useCreditList();

        const table: TableConfig = {
            columns: [
                { type: TableColumnType.Index, label: '#' },
                { type: TableColumnType.Text, label: 'Name', key: 'name' },
                { type: TableColumnType.Text, label: 'Amount', key: 'amount' },
                { type: TableColumnType.Actions, label: 'Actions' }
            ],
            actions: [
                {
                    props: (row: any) => ({
                        icon: 'fa-shipping-fast',
                        theme: 'info',
                        tooltip: 'Add special shop',
                        to: {
                            name: ROUTE_NAME_ITEM.SYSTEM.ADD,
                            query: { feature: InjectionFeature.CreditTicket, data: row.amount }
                        }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-tags',
                        theme: 'info',
                        tooltip: 'Add promo code',
                        to: {
                            name: ROUTE_NAME_PROMOTION.CODE.ADD,
                            query: { feature: InjectionFeature.CreditTicket, data: row.amount }
                        }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-edit',
                        theme: 'info',
                        tooltip: 'Edit',
                        to: { name: ROUTE_NAME_CREDIT.TICKET.EDIT, params: { id: row.id } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-trash-alt',
                        theme: 'danger',
                        tooltip: 'Delete',
                        disabled: !row.canDelete,
                        onClick: () => actions.remove(row.id)
                    })
                }
            ]
        };

        onMounted(fetchList);

        return { table, list, total, fetchList, ROUTE_NAME_CREDIT };
    }
});
